import { Skeleton } from "antd";
import { styled } from "styled-components";

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const StyledSkeletonImage = styled(Skeleton.Image)`
  width: 100% !important;
  height: 100% !important;
  aspect-ratio: 1 / 1 !important;
`;
